import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import "./styles.scss";
import logo from "./logo.png";
import { Link } from "gatsby";
import { Routes } from "../../Constants";

const menus = [
  {
    label: "Zavod",
    path: Routes.O_ZAVODU,
    items: "zavodPages"
  },
  {
    label: "Šola",
    path: Routes.SOLE,
    items: "solaPages"
  },
  {
    label: "Vrtec",
    path: Routes.VRTCI,
    items: "vrtecPages"
  },
  // {
  //   label: 'Projekti',
  //   path: Routes.PROJEKTI
  // },
  // {
  //   label: 'Novice',
  //   path: Routes.NOVICE
  // },
  // {
  //   label: 'Koledar',
  //   path: Routes.KOLEDAR
  // },
  {
    label: "Bolnisnicna sola in vrtec",
    path: Routes.BOLNISNICA,
    items: "bolnisnicaPages"
  },
  {
    label: "Obrazci",
    path: Routes.OBRAZCI
  }
];

export const NavbarTemplate = props => {
  const data = useStaticQuery(graphql`
    query {
      zavodPages: allMarkdownRemark(
        filter: { frontmatter: { templateKey: { eq: "zavod" } } }
        sort: { fields: frontmatter___order, order: ASC }
      ) {
        edges {
          node {
            frontmatter {
              title
            }
            fields {
              slug
            }
          }
        }
      }

      vrtecPages: allMarkdownRemark(
        filter: { frontmatter: { templateKey: { eq: "vrtec" } } }
        sort: { fields: frontmatter___order, order: ASC }
      ) {
        edges {
          node {
            frontmatter {
              title
            }
            fields {
              slug
            }
          }
        }
      }

      solaPages: allMarkdownRemark(
        filter: { frontmatter: { templateKey: { eq: "sola" } } }
        sort: { fields: frontmatter___order, order: ASC }
      ) {
        edges {
          node {
            frontmatter {
              title
            }
            fields {
              slug
            }
          }
        }
      }

      bolnisnicaPages: allMarkdownRemark(
        filter: { frontmatter: { templateKey: { eq: "bolnisnica" } } }
        sort: { fields: frontmatter___order, order: ASC }
      ) {
        edges {
          node {
            frontmatter {
              title
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `);
  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link className="navbar-logo" to="/">
          <img src={logo} alt="OS Ivana Roba" />
          Osnovna šola Ivana Roba
        </Link>
        <ul className="navbar-menu">
          {menus.map(({ label, path, items }) => (
            <li key={path} className="navbar-menuItem">
              <Link
                className={`navbar-menuLink ${items ? 'expandable' : ''}`}
                activeClassName="active"
                to={path}
                partiallyActive
              >
                {label}
              </Link>
              {items && (
                <div className="subMenu">
                  {data[items].edges.map(({ node }) => {
                    const {
                      frontmatter: { title },
                      fields: { slug }
                    } = node;
                    return (
                      <Link
                        className="navbar-menuLink"
                        activeClassName="active"
                        to={`/${slug}`}
                        partiallyActive
                      >
                        {title}
                      </Link>
                    );
                  })}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

const Navbar = () => {
  return <NavbarTemplate />;
};

export { Navbar };
